import {FC} from "react";
import {Line} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import {LearnGraphData} from "@jane/lib/src/api/repositories/learn-repository";

const yAxisConfigurations = {
  'percentage': {
    beginAtZero: true,
    min: 0,
    max: 100,
    ticks: {
      stepSize: 10,
    }
  },
  'numeric': {
    beginAtZero: true,
    ticks: {
      stepSize: 1,
    }
  }
}

export const LineGraph: FC<{ xAxisLabels: string[], yAxisValues: LearnGraphData, dataPointLabel: string, yAxisConfiguration?: keyof typeof yAxisConfigurations }> = ({ xAxisLabels, yAxisValues, dataPointLabel, yAxisConfiguration }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const yConfig = yAxisConfigurations[yAxisConfiguration ?? 'numeric']

  const labels = xAxisLabels
  const pointSize = 2.5;

  const options = {
    scales: {
      y: yConfig,
    },
    responsive: true,
    elements: {
      line: {
        tension: 0.15,
      },
      point: {
        radius: pointSize,
        hoverRadius: pointSize + 2,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: dataPointLabel,
        data: labels.map((l) => yAxisValues[l] ?? 0),
        borderColor: 'rgb(174, 48, 47)',
        backgroundColor: 'rgba(65, 0, 4, 0.5)',
        pointRadius: pointSize,
        pointHoverRadius: pointSize + 2,
        tension: 0.15,
      },
    ],
  };

  return <div className={'p-3'}>
    <Line options={options} data={data}/>
  </div>
}
